import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.user.games_tab,
    props.user.favorites,
    (games_tab, favorites) => {
        return {
            games_tab,
            favorites
        }
    }
)